<template>
  <div :class="`as-goals-scored`">
    <div class="as-goals-scored__head">
      <IconTheShot />
      <span> Cú sút được thực hiện </span>
    </div>
    <div class="as-history">
      <div class="as-history-item">
        <div class="as-history-item__head">
          <div
            class="as-head-tab as-uppercase"
            :class="{
              'as-active': activeTab === 'team',
            }"
            @click="setActiveTab('team')"
          >
            Đội dứt điểm
          </div>
          <div
            class="as-head-tab as-uppercase"
            :class="{
              'as-active': activeTab === 'all',
            }"
            @click="setActiveTab('all')"
          >
            Cú sút toàn trận
          </div>
        </div>
        <div class="as-history-item__body">
          <div class="as-competition">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th v-if="activeTab === 'team'">
                    Số cú sút đã thực hiện/...
                  </th>
                  <th v-if="activeTab === 'all'">Match Shots</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item.title }}</td>
                  <td :class="`as-center ${item.home._class}`">
                    {{ item.home.value }}{{ item.home.is_percent ? "%" : "" }}
                  </td>
                  <td :class="`as-center ${item.away._class}`">
                    {{ item.away.value }}{{ item.away.is_percent ? "%" : "" }}
                  </td>
                  <td :class="`as-center ${item.avg._class}`">
                    {{ item.avg.value }}{{ item.avg.is_percent ? "%" : "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br v-if="activeTab === 'all'" />
          <div class="as-competition" v-if="activeTab === 'all'">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>Offside Stats</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Offsides / Match</td>
                  <td class="as-center">
                    {{ getValueWithMode("home", "offsidesAVG_overall") }}
                  </td>
                  <td class="as-center">
                    {{ getValueWithMode("away", "offsidesAVG_overall") }}
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "offsidesAVG_overall"),
                        getValueWithMode("away", "offsidesAVG_overall")
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Over 0.5 Offsides</td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "home",
                        "over05OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "away",
                        "over05OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over05OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over05OffsidesPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 1.5 Offsides</td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "home",
                        "over15OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "away",
                        "over15OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over15OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over15OffsidesPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 2.5 Offsides</td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "home",
                        "over25OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "away",
                        "over25OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25OffsidesPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 3.5 Offsides</td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "home",
                        "over35OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      getValueWithMode(
                        "away",
                        "over35OffsidesPercentage_overall"
                      )
                    }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35OffsidesPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br v-if="activeTab === 'all'" />
          <div class="as-competition" v-if="activeTab === 'all'">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>Misc Stats</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Fouls Committed / Match</td>
                  <td class="as-center">
                    {{ getValueWithMode("home", "foulsAVG_overall") }}
                  </td>
                  <td class="as-center">
                    {{ getValueWithMode("away", "foulsAVG_overall") }}
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "foulsAVG_overall"),
                        getValueWithMode("away", "foulsAVG_overall")
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Fouled Against / Match</td>
                  <td class="as-center">
                    {{ getValueWithMode("home", "fouls_against_avg_overall", false) }}
                  </td>
                  <td class="as-center">
                    {{ getValueWithMode("away", "fouls_against_avg_overall", false) }}
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "fouls_against_avg_overall", false),
                        getValueWithMode("away", "fouls_against_avg_overall", false)
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Average Possession</td>
                  <td class="as-center">
                    {{ getValueWithMode("home", "possessionAVG_overall") }}%
                  </td>
                  <td class="as-center">
                    {{ getValueWithMode("away", "possessionAVG_overall") }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "possessionAVG_overall"),
                        getValueWithMode("away", "possessionAVG_overall")
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Draw % FT</td>
                  <td class="as-center">
                    {{ getValueWithMode("home", "drawPercentage_overall") }}%
                  </td>
                  <td class="as-center">
                    {{ getValueWithMode("away", "drawPercentage_overall") }}%
                  </td>
                  <td class="as-center">
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "drawPercentage_overall"),
                        getValueWithMode("away", "drawPercentage_overall")
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import IconTheShot from "~src/components/icons/foot_stats/IconTheShot.vue";
import type { IMatch } from "~src/interfaces";
import type {
  IDataKeys,
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

interface IData {
  title: string;
  home: {
    value: number;
    _class: string;
  };
  away: {
    value: number;
    _class: string;
  };
  avg: {
    value: number;
    _class: string;
  };
}

const props = withDefaults(defineProps<Props>(), {
  mode: "as-win",
});

const activeTab = ref("team");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};
const createDataItem = (
  title: string,
  key: string,
  is_stats: boolean = true,
  is_percent: boolean = true
) => {
  const homeValue = getValueWithMode("home", key, is_stats);
  const awayValue = getValueWithMode("away", key, is_stats);
  const avgValue = calculatorAVG(homeValue, awayValue);

  return {
    title,
    home: {
      value: homeValue,
      _class: getClassForItem(homeValue),
      is_percent: is_percent,
    },
    away: {
      value: awayValue,
      _class: getClassForItem(awayValue),
      is_percent: is_percent,
    },
    avg: {
      value: avgValue,
      _class: getClassForItem(avgValue),
      is_percent: is_percent,
    },
  };
};

const data = computed(() => {
  let dataKeys: IDataKeys[] = [
    {
      title: "Số cú sút đã thực hiện",
      key: "shotsAVG_overall",
      is_percent: false,
    },
    {
      title: "Tỷ lệ chuyển đổi cú sút",
      key: "shot_conversion_rate_overall",
      is_percent: true,
      is_stats: false
    },
    {
      title: "Cú sút trúng/Trận đấu",
      key: "shotsOnTargetAVG_overall",
      is_percent: false,
    },
    {
      title: "Cú sút trượt/Trận đấu",
      key: "shotsOffTargetAVG_overall",
      is_percent: false,
    },
    {
      title: "Số lần sút mỗi bàn thắng",
      key: "shots_per_goals_scored_overall",
      is_percent: false,
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 10.5",
      key: "team_shots_over105_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 11.5",
      key: "team_shots_over115_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 12.5",
      key: "team_shots_over125_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 13.5",
      key: "team_shots_over135_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 14.5",
      key: "team_shots_over145_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 15.5",
      key: "team_shots_over155_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 3.5",
      key: "team_shots_on_target_over35_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 4.5",
      key: "team_shots_on_target_over45_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 5.5",
      key: "team_shots_on_target_over55_percentage_overall",
      is_stats: false
    },
  ];

  if (activeTab.value == "all") {
    dataKeys = [
      {
        title: "Match Shots Over 23.5",
        key: "match_shots_over235_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 24.5",
        key: "match_shots_over245_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 25.5",
        key: "match_shots_over255_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 26.5",
        key: "match_shots_over265_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 7.5",
        key: "match_shots_on_target_over75_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 8.5",
        key: "match_shots_on_target_over85_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 9.5",
        key: "match_shots_on_target_over95_percentage_overall",
        is_stats: false,
      },
    ];
  }
  const _data = dataKeys.map((item: IDataKeys) => {
    return createDataItem(
      item.title,
      item.key,
      item.is_stats ?? true,
      item.is_percent ?? true
    );
  });

  return _data;
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", is_stats = true) => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

  if (!__data || !__data.stats) {
    return 0;
  }

  const targetStats = is_stats ? __data?.stats : __data?.stats?.additional_info;

  if (targetStats && targetStats.hasOwnProperty(mode)) {
    return targetStats[mode] as number;
  }

  return 0;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};
</script>

<script lang="ts">
export default {};
</script>
